<template>
<div ref="viewer"  style="width:100%;height:1000px;margin-top: 100px;position: absolute; left: 0; right: 0; top: 0; bottom: 0" data-bind="dxReportViewer: $data"></div>
</template>

<script>
import ko from "knockout";
import "devexpress-reporting/dx-webdocumentviewer";
import  DevExpress  from "@devexpress/analytics-core";  
import { domain } from '@/gloabelConstant.js'
export default {
name: "WebDocumentViewer",
mounted() {
  // DevExpress.Report.Preview.AsyncExportApproach = true;
  // DevExpress.Analytics.Utils.ajaxSetup.ajaxSettings = { headers: { 'Authorization': "bearer "+localStorage.getItem("accessToken") } };

debugger
    var viewerOptions = {
        reportUrl: ko.observable("AsdReport"), // The URL of a report.
        requestOptions: {
        host: domain,
            // Use this line if you use an ASP.NET MVC backend
            // invokeAction: "api/CustomWebDocumentViewer/Invoke"
            // Uncomment this line if you use an ASP.NET Core backend
         invokeAction: "DXXRDV",
        },
    };
    ko.applyBindings(viewerOptions, this.$refs.viewer);
},
beforeDestroy() {
    ko.cleanNode(this.$refs.viewer);
} 
};
</script>